import { render, staticRenderFns } from "./add-vessel-client.vue?vue&type=template&id=28a55a92&scoped=true"
import script from "./add-vessel-client.vue?vue&type=script&lang=js"
export * from "./add-vessel-client.vue?vue&type=script&lang=js"
import style0 from "./add-vessel-client.vue?vue&type=style&index=0&id=28a55a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a55a92",
  null
  
)

export default component.exports